export const composeSendButton = "yoRiY";
export default {composeSendButton};